import React from 'react';
import { Col } from 'antd';
import { WorkersFormItem } from '@/components/views/Resolution886/components/Form';

export function WorkersName(): JSX.Element {
	return (
		<Col xs={24}>
			<WorkersFormItem fieldName="worker_list_id" required={false} disabled={true} />
		</Col>
	);
}
